"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediabaseDeliveryAgentClips3Schema = void 0;
exports.MediabaseDeliveryAgentClips3Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/3.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MediabaseDeliveryAgentClips3",
    "description": "Mediabase delivery agent for video preview clips",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:mediabase-delivery-agent-clip:3"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "assetId": {
                    "type": "string",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "VIN": {
                    "type": "string",
                    "pattern": "^MI[0-9]+$"
                },
                "renditions": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "additionalProperties": false,
                        "properties": {
                            "clipURL": {
                                "type": "string",
                                "description": "URL to mediabase clip delivery agent",
                                "format": "uri"
                            },
                            "height": {
                                "type": "number",
                                "description": "Frame size height of the video in pixels"
                            },
                            "ratio": {
                                "type": "number",
                                "description": "The calculated ratio, width/height",
                                "minimum": 0
                            },
                            "ratioTextual": {
                                "type": "string",
                                "description": "The cropping ratio in textual form of `{width}x{heigth}`, e.g. 4x3",
                                "pattern": "^[\\d]+x[\\d]+$"
                            },
                            "width": {
                                "type": "number",
                                "description": "Frame size width of the video in pixels"
                            }
                        },
                        "required": [
                            "clipURL",
                            "height",
                            "ratio",
                            "ratioTextual",
                            "width"
                        ]
                    },
                    "minItems": 1
                }
            },
            "required": [
                "renditions"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9tZWRpYWJhc2UtZGVsaXZlcnktYWdlbnQtY2xpcC8zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELEtBQUssRUFBRSxrR0FBa0c7SUFDekcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsOEJBQThCO0lBQ3ZDLGFBQWEsRUFBRSxrREFBa0Q7SUFDakUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMERBQTBEO2FBQzNEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFNBQVMsRUFBRSxtREFBbUQ7aUJBQy9EO2dCQUNELEtBQUssRUFBRTtvQkFDTCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsU0FBUyxFQUFFLFlBQVk7aUJBQ3hCO2dCQUNELFlBQVksRUFBRTtvQkFDWixNQUFNLEVBQUUsT0FBTztvQkFDZixPQUFPLEVBQUU7d0JBQ1AsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLHNCQUFzQixFQUFFLEtBQUs7d0JBQzdCLFlBQVksRUFBRTs0QkFDWixTQUFTLEVBQUU7Z0NBQ1QsTUFBTSxFQUFFLFFBQVE7Z0NBQ2hCLGFBQWEsRUFBRSxzQ0FBc0M7Z0NBQ3JELFFBQVEsRUFBRSxLQUFLOzZCQUNoQjs0QkFDRCxRQUFRLEVBQUU7Z0NBQ1IsTUFBTSxFQUFFLFFBQVE7Z0NBQ2hCLGFBQWEsRUFBRSwwQ0FBMEM7NkJBQzFEOzRCQUNELE9BQU8sRUFBRTtnQ0FDUCxNQUFNLEVBQUUsUUFBUTtnQ0FDaEIsYUFBYSxFQUFFLG9DQUFvQztnQ0FDbkQsU0FBUyxFQUFFLENBQUM7NkJBQ2I7NEJBQ0QsY0FBYyxFQUFFO2dDQUNkLE1BQU0sRUFBRSxRQUFRO2dDQUNoQixhQUFhLEVBQUUsb0VBQW9FO2dDQUNuRixTQUFTLEVBQUUsaUJBQWlCOzZCQUM3Qjs0QkFDRCxPQUFPLEVBQUU7Z0NBQ1AsTUFBTSxFQUFFLFFBQVE7Z0NBQ2hCLGFBQWEsRUFBRSx5Q0FBeUM7NkJBQ3pEO3lCQUNGO3dCQUNELFVBQVUsRUFBRTs0QkFDVixTQUFTOzRCQUNULFFBQVE7NEJBQ1IsT0FBTzs0QkFDUCxjQUFjOzRCQUNkLE9BQU87eUJBQ1I7cUJBQ0Y7b0JBQ0QsVUFBVSxFQUFFLENBQUM7aUJBQ2Q7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixZQUFZO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==